import Documento from "../assets/img/svg/providers/documento.svg";
import Ubicacion from "../assets/img/svg/providers/ubicacion.svg";
import CentroCarga from "../assets/img/svg/projects/centrodeCarga.svg";
import Proyecto from "../assets/img/svg/projects/Proyecto.svg";
import NuevoProyecto from "../assets/img/svg/projects/NuevoProyecto.svg";

export const itemsProjects = [
  {
    texto: "Clientes",
    icon: <img src={Documento} alt="Clientes" />,
    url: "/proyectos/clientes",
  },
  {
    texto: "Centros de carga",
    icon: <img src={CentroCarga} alt="Inicio" />,
    url: "/proyectos/centros",
  },
  {
    texto: "EDTs",
    icon: <img src={Documento} alt="EDTs" />,
    url: "/proyectos/edts",
  },
  {
    texto: "Nuevo proyecto",
    icon: <img src={NuevoProyecto} alt="Inicio" />,
    url: "/proyectos/nuevo",
  },
  {
    texto: "Proyectos",
    icon: <img src={Proyecto} alt="Inicio" />,
    url: "/proyectos/todos",
  },
  {
    texto: "Mapa de proyectos",
    icon: <img src={Ubicacion} alt="Mapa de Proyectos" />,
    url: "/proyectos/mapa",
  },
];

export const statusOptions = [
  { value: null, label: "Todos" },
  { value: 137, label: "Concluido" },
  { value: 138, label: "En proceso" },
  { value: 373, label: "Inactivo" },
];

export const defaultCriterios = {
  id: null,
  nombre: null,
  puntoCarga: null,
  rpu: null,
  proyecto: null,
  cliente: null,
  permisionario: null,
  empresa: null,
  tipoTrabajo: null,
  estatus: null,
  direccion: null,
  parametro: null,
  latitude: null,
  longitude: null,
  estado: null,
  nivelTension: null,
  demandaContratada: null,
  porcentajeFotos: null,
  porcentajeParametros: null,
  faseTrabajoFilter: null,
};

export const defaultCriteriosWithId = {
  id: null,
  nombre: null,
  puntoCarga: null,
  rpu: null,
  proyecto: { id: 64 },
  cliente: null,
  permisionario: null,
  empresa: null,
  tipoTrabajo: null,
  estatus: null,
  direccion: null,
  parametro: null,
  latitude: null,
  longitude: null,
  estado: null,
  nivelTension: null,
  demandaContratada: null,
  porcentajeFotos: null,
  porcentajeParametros: null,
  faseTrabajoFilter: null,
};

export const porcentajesFilters = [
  {
    label: "Todos",
    value: null,
  },
  {
    label: "0%",
    value: "0-0",
  },
  {
    label: "1% - 25%",
    value: "1-25",
  },
  {
    label: "26% - 50%",
    value: "26-50",
  },
  {
    label: "51% - 75%",
    value: "51-75",
  },
  {
    label: "76% - 100%",
    value: "76-100",
  },
];

export const tenstionFilters = [
  { value: null, label: "Todos" },
  { value: "BT", label: "BT" },
  { value: "MT", label: "MT" },
  { value: "AT", label: "AT" },
];

export const demandaFilters = [
  { label: "kW", value: "kW" },
  { label: "MW", value: "MW" },
  { label: "GW", value: "GW" },
];
